// Referências internas
const permissaoUsuario = require('./permissaoUsuario');

function checkAuth() {
    // const currentDate = new Date();

    const token = JSON.parse(localStorage.getItem('sgc_br'));

    if (!token) {
        return false;
    }
    
    return true;
}

function checkAdmin() {
    // const currentDate = new Date();

    const token = JSON.parse(localStorage.getItem('sgc_br'));

    if (!token) {
        return false;
    }

    if (permissaoUsuario.verificar(50, token.tipo_usuario)) {
        return true;
    } else {
        return false;
    }
}

function checkAuthNivel(nivelPermissaoUsuario) {
    const token = JSON.parse(localStorage.getItem('sgc_br'));

    if (!token) {
        return false;
    }

    if (permissaoUsuario.verificar(nivelPermissaoUsuario, token.tipo_usuario)) {
        return true;
    } else {
        return false;
    }
}

export { checkAuth, checkAdmin, checkAuthNivel };